export default __webpack_public_path__ + "d0bfb06c1c5bbdf378b95cec94e89d96.svg";